// Thin, safe wrapper around the Microsoft Clarity global (loaded in public/index.html).
// No-ops if Clarity hasn't loaded — blocked, offline, or local dev without network —
// so analytics can never break the app.
export function claritySet(key, value) {
  try {
    if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
      window.clarity('set', key, value);
    }
  } catch {
    // Swallow: instrumentation must never surface to the user.
  }
}
